import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  container: {
    "@media (max-width:899.95px)": { width: "100%" },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  subContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "100%", maxWidth: "674px",
    minWidth: 0,
  },
  content: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "20px",
  },
  contentSelect: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    justifyContent: "space-between",
    "& > div": {
      flex: 1,
      margin: 0,
    },
  },
  containerAllButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  containerButton: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
  },
});

export default useStyles;
